import { useFeatureFlag } from 'features/feature-set/useFeatureFlag';
import { selectIsLockedContentReadOnly } from 'features/layout/features/content/contentSlice';
import { PermissionTypes } from 'features/permissions/types';
import { usePermissions } from 'features/permissions/usePermissions';
import { useSystemSession } from 'hooks/useSystemSession';
import { GridPanelControl } from 'features/layout/grid-panel/GridPanelControl';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import {
  fileClosed,
  selectContentLibraryOpenedFile,
} from 'features/content-library/contentLibrarySlice';
import { useTranslation } from 'react-i18next';

export const useFilePanelCloseControl = () => {
  const dispatch = useAppDispatch();
  const isSystemSession = useSystemSession();

  const { t } = useTranslation('room');

  const { hasPermissions } = usePermissions();

  const canClose = hasPermissions(PermissionTypes.presentContentLibrary);
  const isLockedContentReadOnly = useAppSelector(selectIsLockedContentReadOnly);

  const isFeatureEnabled = useFeatureFlag('contentLibrary');

  const controlEnabled = isSystemSession
    ? false
    : isFeatureEnabled && canClose && !isLockedContentReadOnly;

  const openedFile = useAppSelector(selectContentLibraryOpenedFile);

  const handleClick = () => {
    if (openedFile) {
      dispatch(fileClosed(openedFile.id));
    }
  };

  return {
    controlEnabled,
    handleClick,
    tooltip: t('tooltips.close_content'),
  };
};

export const ContentCloseControl = () => {
  const { controlEnabled, handleClick, tooltip } = useFilePanelCloseControl();
  return controlEnabled ? (
    <GridPanelControl tooltip={tooltip} icon="close" onClick={handleClick} />
  ) : null;
};
